// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bResizer {
  border-top: 1px solid #e2e2e2;
  height: 10px;
  margin: 15px -15px;
  background: #f5f5f5;
  position: relative;
  cursor: row-resize;
  flex-shrink: 0;
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
  z-index: 1;
}

.bResizer::after,
.bResizer::before {
  content: '';
  border-top: 1px solid #333132;
  position: absolute;
  left: 50%;
  transform: translateX(-100%);
  bottom: 3px;
  display: inline-block;
  width: 20px;
  margin: 0 2px;
}
.bResizer::before {
  top: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ResizablePanel/ResizablePanel.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,yBAAyB,EAAE,4BAA4B;EACvD,sBAAsB,EAAE,gBAAgB;EACxC,qBAAqB,EAAE,WAAW;EAClC,iBAAiB,EAAE,kBAAkB;EACrC,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;EACT,4BAA4B;EAC5B,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,aAAa;AACf;AACA;EACE,QAAQ;AACV","sourcesContent":[".bResizer {\n  border-top: 1px solid #e2e2e2;\n  height: 10px;\n  margin: 15px -15px;\n  background: #f5f5f5;\n  position: relative;\n  cursor: row-resize;\n  flex-shrink: 0;\n  -webkit-user-select: none; /* Chrome all / Safari all */\n  -moz-user-select: none; /* Firefox all */\n  -ms-user-select: none; /* IE 10+ */\n  user-select: none; /* Likely future */\n  z-index: 1;\n}\n\n.bResizer::after,\n.bResizer::before {\n  content: '';\n  border-top: 1px solid #333132;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-100%);\n  bottom: 3px;\n  display: inline-block;\n  width: 20px;\n  margin: 0 2px;\n}\n.bResizer::before {\n  top: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
